import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { StyledEngineProvider } from '@mui/material/styles';

import Router from '@/views/Router';

import { appActions } from "@/store/actions/app.actions";
import api from '@/services/api';

import DictionaryModalContextProvider from '@/utils/contexts/DictionaryModalContext';

import Cookies from "@/views/components/Cookies/Cookies";

const App = () => {
	const dispatch = useDispatch();
	const currentAppState = useSelector((state) => state.app);
	const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
	const [ configLoaded, setConfigLoaded ] = useState(false);

	const loadConfigFile = async () => {
		const response = await fetch(
			`/config/config.json`,
			{
				method: 'GET',
			},
		);
		const config = await response.json();
		dispatch(appActions.setConfigFile(config));
		setConfigLoaded(true);
	};

	const loadLetterTemplatesSettings = async () => {
		api.get('/letter-templates/settings').then((response) => {
			dispatch(appActions.setLetterTemplatesSettings(response.data));
		});
	};

	const loadInstanceConfiguration = async () => {
		api.get('/configuration').then((response) => {
			dispatch(appActions.setInstanceConfiguration(response.data));
		});
	};

	useEffect(() => {
		loadConfigFile();
	}, []);

	useEffect(() => {
		if (configLoaded && isLoggedIn) {
			loadLetterTemplatesSettings();
			loadInstanceConfiguration();
		}
	}, [ configLoaded, isLoggedIn ]);

	useEffect(() => {
		dispatch(appActions.saveCookie());
	}, [ currentAppState, dispatch ]);

	if (configLoaded) {
		return (
			<StyledEngineProvider injectFirst>
				<DictionaryModalContextProvider>
					<Router />
				</DictionaryModalContextProvider>
				{currentAppState.cookiePermission !== true &&
				<Cookies />}
			</StyledEngineProvider>
		);
	}

	return <></>;
};

export default App;
